import {Component, Input} from '@angular/core';
import {DatePipe, NgClass} from '@angular/common';
import {RotinaProgramadaModel} from '../../shared/model/rotina-programada/rotina-programada-model';

@Component({
  selector: 'app-card-job',
  standalone: true,
  imports: [
    DatePipe,
    NgClass
  ],
  templateUrl: './card-job.component.html',
  styleUrl: './card-job.component.css'
})
export class CardJobComponent {

  @Input() tarefa?: RotinaProgramadaModel;


  getStatus(): string {
    if(this.tarefa?.status === 'CONCLUIDO'){
      return 'CONCLUÍDO';
    }
    else if(this.tarefa?.status === 'EM_ANDAMENTO'){
      return 'EM ANDAMENTO';
    }
    return `${this.tarefa?.status}`;
  }


}
